var ShowModal = "none";

export default function(state = ShowModal, action) {
  if (action.type === "ShowModal") {
    console.log(action.payload);

    if (
      ShowModal === "none" ||
      action.payload === "none" ||
      action.payload === "login"
    ) {
      ShowModal = action.payload;
    }
  }
  return ShowModal;
}



// WEBPACK FOOTER //
// ./src/reducers/modal-reducer.js